import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-columnist-content',
  templateUrl: './columnist-content.component.html',
  styleUrls: ['./columnist-content.component.scss'],
})
export class ColumnistContentComponent {
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  @Input() isColumnistContent: FormControl;
}
